import '../App.css';
import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import  { Redirect } from 'react-router-dom'

class callback extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
        user: null,
        redirect: false
    }

  }

  async componentDidMount() {
    // TODO: Get the 'code' part from the url, then redirect to discordLogin.js with code as param. 
    // TODO: login = get.login() 

    // TODO: redirect using login.url
    // TODO: After redirection -> code = get the argument 'code' from the url 
    // TODO: token = post.verify(code)
    //console.log("HERE")
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let code = params.get('code');
    const post_url = "/.netlify/functions/post?code=" + code;
    const site = "https://gym-bro-bot.netlify.app";
    // TODO: Make call to back end of: token = post.verify(code)
    /*fetch("https://www.gym-bro-bot.com" + post_url)
    .then(response => response.json())
    .then(data => {
        data = JSON.stringify(data);
        data = JSON.parse(data);
        console.log(data);
        //this.setState( {token_data: data.body} );
        //console.log(this.state.token_data)
    });
    */

    // Log the user in using the Netlify function for login
    let response = await fetch(site + post_url);
    console.log(response);
    let data = await response.json();
    // If the login was successful 
    if (data !== false) {
      this.setState( {user: data} );
      console.log(this.state.user);
      // TODO: Redirect user to login page with passing in the data 
      // Set the value of redirect to true -> so in render it knows to redirect now
      this.setState( {redirect: true} )
    }


    /*
    response = await fetch("https://discord.com/api/users/@me", {
        method: 'GET',
        headers: {'Authorization': `Bearer ${this.state.token_data.access_token}`}
    });
    data = await response.json();
    this.setState( {user: data} );
    console.log(this.state.user);
    */

  }

  render() {

    if (this.state.redirect) {
      return (
        <Redirect to={{
          pathname:'/discordLogin',
          state: { user: this.state.user }
        }} 
        />
      );
    }

    return (
      <div className="App">
        <Navbar />

        <header className="App-header">
        <p>Logging in...</p>
        </header>



      </div>
    );
  }

}

export default callback;